export default __webpack_public_path__ + "static/media/payment.30531190.svg";